module.exports = __webpack_public_path__ + "static/media/unknown.b340132d.svg";